import React from 'react';
import { ScheduleCellProps } from './types';
import { formatScheduleDateTime } from '../DeliveryDaysExpand';

const StartDateCell = ({ row, timezone }: ScheduleCellProps) => {
  const startTime = row?.original?.start_time;

  if (!startTime) {
    return null;
  }

  return <>{formatScheduleDateTime(startTime, timezone)}</>;
};

export default StartDateCell;
